module.exports = __webpack_public_path__ + "img/decoration-diamond.1c0316dd.svg";